import ImageComponent from '@/components/ui/image';
import routes from '@/config/routes';
import {
  useModalAction,
  useModalState,
} from '@/components/modal-views/context';
import AnchorLink from '@/components/ui/links/anchor-link';
import ProductSocialShare from '@/components/product/product-social-share';
import ProductInformation from '@/components/product/product-information';
import ProductThumbnailGallery from '@/components/product/product-thumbnail-gallery';
import AddToCart from '@/components/cart/add-to-cart';
import { isFree } from '@/lib/is-free';
import FreeDownloadButton from '@/components/product/free-download-button';
import { useProduct } from '@/data/product';
import isEmpty from 'lodash/isEmpty';
import FavoriteButton from '@/components/favorite/favorite-button';
import { useTranslation } from 'next-i18next';
import Link from 'next/link';
import usePrice from '@/lib/hooks/use-price';
import { Avatar, Tooltip } from '@nextui-org/react';
import ProductQuestions from '../questions/product-questions';
import { getReview } from '@/lib/get-reviews';
import Button from '../ui/button-old';
import ComposeText from '../ui/compose-text';
import ProductFeatures from './product-features';
import ProductPrice from './product-price';
import ProductReviewWidget from './product-review-widget';
import { DownloadIcon } from '../icons/download-icon';
import { useInSuccessfulOrders } from '@/lib/hooks/use-in-orders';
import { Product } from '@/types';
import FollowButton from '../follow/follow-button';
import ProductAttributes from './product-attributes';
import useAuth from '../auth/use-auth';
import ProductPopupLoader from './product-popup-loader';
import { useMutation } from 'react-query';
import client from '@/data/client';

function getPreviews(gallery: any[], image: any) {
  if (!isEmpty(gallery) && Array.isArray(gallery)) return gallery;
  if (!isEmpty(image)) return [image];
  return [{}];
}

const ImageDownloader = ({
  name,
  imageUrl,
  className = '',
}: {
  name: string;
  imageUrl: string;
  className?: string;
}) => {
  // TODO: doens't work
  // const handleDownload = async (outputFormat = 'image/png') => {
  //   try {
  //     const response = await fetch(imageUrl);
  //     const blob = await response.blob();

  //     const canvas = document.createElement('canvas');
  //     const ctx = canvas.getContext('2d');

  //     const src = URL.createObjectURL(blob);
  //     const img = new Image();
  //     // img.crossOrigin = 'anonymous'; // Add this line
  //     img.src = src;
  //     img.onload = () => {
  //       canvas.width = img.width;
  //       canvas.height = img.height;
  //       ctx.drawImage(img, 0, 0);
  //       canvas.toBlob((blob) => {
  //         const newImgUrl = URL.createObjectURL(blob);
  //         const link = document.createElement('a');
  //         link.href = newImgUrl;
  //         link.download = `${name}_prompt_example_image.${
  //           outputFormat.split('/')[1]
  //         }`;
  //         link.click();
  //         URL.revokeObjectURL(newImgUrl);
  //       }, outputFormat);
  //     };
  //   } catch (error) {
  //     console.error('Error downloading or converting image:', error);
  //   }
  // };

  return (
    <Tooltip content={`Download HQ image`} placement="top">
      <a
        href={imageUrl}
        className={className}
        download
        target="_blank"
        aria-label={`Download ${name} image`}
      >
        <DownloadIcon height={20} width={20} className="text-light-base" />
      </a>
    </Tooltip>
    // TODO: doesn't work
    //   <NextButton
    //     isIconOnly
    //     disableRipple
    //     className={className}
    //     aria-label={`Download ${name} image`}
    //     // onClick={() => handleDownload('image/png')}
    //     href={imageUrl}
    //     target='_blank'
    //   >
    //     <DownloadIcon height={20} width={20} className="text-light-base" />
    //   </NextButton>
  );
};

export default function ProductDetailsWidget({
  productSSR,
  productSlug,
}: {
  productSSR: Product;
  productSlug?: string;
}) {
  const { t } = useTranslation('common');
  const { file } = useInSuccessfulOrders(productSSR?.id);
  const { openModal } = useModalAction();
  const { image, gallery, type } = productSSR;
  const { product } = useProduct(productSSR?.slug, productSSR);
  const in_orders = product?.has_purchased || productSSR?.has_purchased;

  const { my_review, order_id } = file?.file.fileable ?? {};
  // const { settings, updateSettings } = useNSFWSettings();
  // const isNSFW = productSSR.tags?.some(tag => tag.name === 'Anime') ?? false;
  // const [showModal, setShowModal] = useState(false);
  // const [isHydrated, setIsHydrated] = useState(false);
  // const router = useRouter();
  // const [localMature, setLocalMature] = useState(settings.mature);
  // const [localExplicit, setLocalExplicit] = useState(settings.explicit);

  // Handle hydration
  // useEffect(() => {
  //   setIsHydrated(true);
  // }, []);

  // Show modal only after hydration if content is NSFW and not confirmed
  // useEffect(() => {
  //   if (isHydrated && isNSFW && !settings.confirmed18) {
  //     setShowModal(true);
  //     setLocalMature(settings.mature);
  //     setLocalExplicit(settings.explicit);
  //   }
  // }, [isHydrated, isNSFW, settings.confirmed18, settings.mature, settings.explicit]);

  // const handleNSFWConfirm = () => {
  //   updateSettings({
  //     mature: localMature,
  //     explicit: localExplicit,
  //     confirmed18: true,
  //   });
  //   setShowModal(false);
  // };

  // const handleNSFWCancel = () => {
  //   setLocalMature(false);
  //   setLocalExplicit(false);
  //   updateSettings({
  //     mature: false,
  //     explicit: false,
  //     confirmed18: false,
  //   });
  //   setShowModal(false);
  //   router.push(routes.home);
  // };

  // const NSFWModal = () => {
  //   if (!showModal) return null;

  //   return (
  //     <div className="fixed inset-0 z-50 flex items-center justify-center">
  //       <div className="fixed inset-0 bg-black/50 backdrop-blur-sm" />
  //       <div className="relative z-50 w-full max-w-md rounded-lg bg-background p-6 shadow-xl">
  //         <div className="flex flex-col items-center gap-4">
  //           <div className="h-1.5 w-12 rounded-full bg-gradient-to-r from-violet-500 to-fuchsia-500" />
  //           <h2 className="text-lg font-medium">Adult Content Warning</h2>
  //           <p className="text-center text-sm text-foreground/80">
  //             This content contains mature themes. Please verify your age to continue.
  //           </p>
  //           {/* <NSFWContent
  //             onConfirm={handleNSFWConfirm}
  //             onCancel={handleNSFWCancel}
  //             className="w-full"
  //             localMature={localMature}
  //             setLocalMature={setLocalMature}
  //             localExplicit={localExplicit}
  //             setLocalExplicit={setLocalExplicit}
  //           /> */}
  //         </div>
  //       </div>
  //     </div>
  //   );
  // };

  const previews = getPreviews(
    (!in_orders && type?.name === 'Image') || type?.name !== 'Image'
      ? gallery
      : product
      ? product.prompt_example
      : gallery,
    image
  );
  const openReviewModal = (record: any) => {
    openModal('REVIEW_RATING', {
      product_id: record.id,
      shop_id: record.shop_id,
      order_id,
      name: record.name,
      image: record.image,
      my_review: getReview(record?.my_review, record?.order_id),
      ...(record.pivot?.variation_option_id && {
        variation_option_id: record.pivot?.variation_option_id,
      }),
    });
  };

  // Don't show loading state, let the page render normally
  return (
    <div className="flex max-w-full flex-col text-left xs:max-w-[430px] sm:max-w-[550px] md:max-w-[600px] lg:max-w-[960px] xl:max-w-[1200px] 2xl:max-w-[1266px] 3xl:max-w-[1460px]">
      {/* <NSFWModal /> */}
      <div className="flex flex-col px-4 rtl:space-x-reverse md:px-6 lg:flex-row lg:space-x-7 xl:space-x-8 xl:px-8 3xl:space-x-10">
        <div className="mb-4 w-full max-w-[500px] shrink-0 items-center justify-center overflow-hidden md:mb-6 lg:mb-auto">
          <div className="relative">
            <ProductThumbnailGallery
              gallery={previews}
              isVideoProduct={productSSR?.type?.slug === 'video'}
              titlePrefixGallery={`Preview of ${productSSR?.ai_model.name} Prompt ${productSSR?.name}`}
              titlePrefixThumbGallery={`View preview of ${productSSR?.ai_model.name} Prompt ${productSSR?.name}`}
              altPrefixGallery={`${productSSR?.ai_model.name} ${productSSR?.ai_model_version.name} Prompt for ${productSSR?.name} Preview`}
              altPrefixThumbGallery={`${productSSR?.ai_model.name} ${productSSR?.ai_model_version.name} Prompt for ${productSSR?.name} Thumbnail`}
              // className={isNSFW && !settings.confirmed18 ? 'blur-sm' : ''}
            />
          </div>
          <div className="mt-4 hidden w-full md:mt-8 md:space-y-10 lg:mt-12 lg:flex lg:flex-col lg:space-y-12">
            <ProductReviewWidget product={productSSR} />
            {/* <ProductReviews productId={id} ratings={ratings} /> */}
            {in_orders && (
              <>
                <Button
                  onClick={() =>
                    in_orders ? openReviewModal(productSSR) : null
                  }
                  disabled={in_orders ? false : true}
                >
                  {!in_orders
                    ? ''
                    : getReview(my_review, order_id as any)
                    ? t('text-update-review')
                    : t('text-write-review')}
                </Button>
                <span className="!mt-4 text-center italic">
                  How happy are you with your purchase? Did the prompt perform
                  as you anticipated? We&apos;`d love to hear your feedback on
                  this prompt!
                </span>
              </>
            )}
            <ProductQuestions
              productId={productSSR?.id}
              shopId={productSSR?.shop?.id}
              className="hidden"
            />
          </div>
        </div>
        <ProductDetailsWidgetClient
          productSlug={productSlug}
          productSSR={productSSR}
        />
      </div>
    </div>
  );
}

const highlightBrackets = (text: string) => {
  // Split the text by bracketed content using regex
  const parts = text.split(/(\[.*?\])/g);

  return parts.map((part, index) => {
    // Check if the part is inside square brackets
    if (part.startsWith('[') && part.endsWith(']')) {
      return (
        <span key={index} className="text-brand">
          {part}
        </span>
      );
    } else {
      // Return the plain text part
      return part;
    }
  });
};

export function ProductDetailsWidgetClient({
  productSSR,
  productSlug,
}: {
  productSSR: Product;
  productSlug?: string;
}) {
  const { data } = useModalState();
  const { t } = useTranslation('common');
  const auth = useAuth();
  const { product, isLoading, isRefetching } = useProduct(
    data?.slug ?? productSlug,
    auth.isAuthorized,
    productSSR
  );
  const { file } = useInSuccessfulOrders(
    parseInt(product?.id ?? '0', 10)
  );
  const in_orders = product?.has_purchased;
  const isLoadingOrders = isLoading;
  // console.log(product?.has_purchased);
  const { price, basePrice, discount } = usePrice({
    amount: product?.sale_price ? product?.sale_price : product?.price ?? -1,
    baseAmount: product?.price,
  });
  const { openModal } = useModalAction();
  const { mutate } = useMutation(client.orders.generateDownloadLink, {
    onSuccess: (data) => {
      function download(fileUrl: string, fileName: string) {
        let a = document.createElement('a');
        a.href = fileUrl;
        a.setAttribute('download', fileName);
        a.click();
      }

      download(data, name);
    },
  });
  // check if user is logged in
  if (auth.isAuthorized && in_orders && !product?.prompt_template)
    if (isLoading || isLoadingOrders || !product || isRefetching)
      //     // TODO: check prompt_example other way?
      return <ProductPopupLoader />;
  // if (!product) return <div>{t('text-not-found')}</div>;
  const {
    id,
    name,
    description,
    slug,
    shop,
    updated_at,
    created_at,
    orders_count,
    views_count,
    word_count,
    has_tips,
    ai_model_version,
    tested,
    tags,
    preview_url,
    type,
    sale_price,
    is_external,
    external_product_url,
    external_product_button_text,
    ai_model,
    categories,
  } = product ?? {};
  const isFreeItem = isFree(sale_price ?? product.price);
  const model_version = ai_model_version.name;

  const { order_id, my_review } = file?.file.fileable ?? {};

  const openReviewModal = (record: any) => {
    openModal('REVIEW_RATING', {
      product_id: record.id,
      shop_id: record.shop_id,
      order_id,
      name: record.name,
      image: record.image,
      my_review: getReview(record?.my_review, record?.order_id),
      ...(record.pivot?.variation_option_id && {
        variation_option_id: record.pivot?.variation_option_id,
      }),
    });
  };

  return (
    <>
      <div className="flex shrink-0 flex-col justify-between text-13px lg:w-[400px] xl:w-[600px] 3xl:w-[655px]">
        <div className="pb-7 xs:pb-8 lg:pb-10">
          {!in_orders && (
            <ProductPrice
              basePrice={basePrice}
              discount={discount}
              price={price}
            />
          )}
          <div className="my-2 flex flex-shrink-0 items-center">
            <h1
              title={name}
              className="break-words text-base leading-tight text-dark-600 dark:text-light-800"
              data-buy-box-listing-title="true"
            >
              {name}
            </h1>
            <FavoriteButton className="ml-2" size="xs" productId={id ?? ''} />
          </div>
          <div className="flex flex-shrink-0 items-center py-1">
            <div className="relative flex h-5 w-5 flex-shrink-0 md:h-6 md:w-6">
              {shop?.logo?.thumbnail ? (
                <ImageComponent
                  alt={shop.name}
                  quality={100}
                  src={shop.logo?.thumbnail}
                  className="rounded-full object-cover"
                  width={28}
                  height={28}
                />
              ) : shop?.name ? (
                <Avatar name={shop.name} size="sm" className="rounded-full" />
              ) : null}
            </div>
            {shop?.name && (
              <h3
                title={shop.name}
                className="text-13px font-medium text-dark-600 ltr:pl-2 rtl:pr-2 dark:text-light-800 ltr:md:pl-2.5 rtl:md:pr-2.5"
              >
                <AnchorLink
                  href={routes.shopUrl(shop.slug)}
                  className="hover:text-accent transition-colors"
                >
                  {shop.name}
                </AnchorLink>
              </h3>
            )}
            {shop?.id && (
              <div className="ml-2">
                <FollowButton size="xs" shop_id={shop.id} />
              </div>
            )}
          </div>
          {!in_orders ? (
            <>
              <div className="mt-4 flex flex-col xs:gap-2.5 xs:pb-4 md:flex-row md:items-center md:gap-3.5 lg:gap-4">
                {is_external ? (
                  <Link
                    href={external_product_url}
                    target="_blank"
                    className="transition-fill-colors pointer-events-auto relative mt-2.5 flex min-h-[46px] w-full flex-1 cursor-pointer items-center justify-center gap-2 rounded bg-brand py-3 px-4 font-semibold text-white opacity-100 duration-200 hover:bg-brand-dark focus:bg-brand-dark xs:mt-0 sm:h-12 md:px-5"
                  >
                    {external_product_button_text}
                  </Link>
                ) : !isFreeItem ? (
                  <AddToCart
                    item={product}
                    status={product.status}
                    toastClassName="-mt-10 xs:mt-0"
                    className="mt-2.5 w-full flex-1 xs:mt-0"
                  />
                ) : (
                  <FreeDownloadButton
                    productId={id}
                    productSlug={slug}
                    productName={name}
                    className="mt-2.5 w-full flex-1 xs:mt-0"
                  />
                )}

                {Boolean(preview_url) && (
                  <a
                    href={preview_url}
                    rel="noreferrer"
                    target="_blank"
                    className="transition-fill-colors flex min-h-[46px] w-full flex-1 items-center justify-center gap-2 rounded border border-light-500 bg-transparent py-3 px-4 font-semibold text-dark duration-200 hover:bg-light-400 hover:text-brand focus:bg-light-500 dark:border-dark-600 dark:text-light dark:hover:bg-dark-600 dark:focus:bg-dark-600 sm:h-12 md:px-5"
                  >
                    {t('text-live-preview')}
                  </a>
                )}
              </div>
              <div className="mb-4 text-center text-[12px] italic text-gray-600 dark:text-light-900">
                Once you complete your purchase, you&apos;ll receive the prompt
                file, which is compatible with {ai_model?.name}. Please ensure
                you have access to {ai_model?.name} beforehand. By buying this
                prompt, you agree to our{' '}
                <Link href={routes.terms} target="_blank" className="underline">
                  terms of service
                </Link>
                .
              </div>
            </>
          ) : (
            <ProductAttributes product={product} />
          )}
          {!is_external && (
            <div className="flex space-x-6 border-t border-light-500 py-3 rtl:space-x-reverse dark:border-dark-500 md:py-4 3xl:py-5">
              <ProductFeatures
                ai_model={ai_model}
                has_tips={has_tips}
                typeName={type.name}
                model_version={model_version}
                tested={tested}
                word_count={word_count}
              />
              {/* <div className="flex items-center tracking-[.1px] text-dark dark:text-light">
                  <DownloadIcon className="h-[18px] w-[18px] text-dark-900 ltr:mr-2.5 rtl:ml-2.5 dark:text-light-800" />
                  {pluralize(t('text-download'), total_downloads, true)}
                </div> */}
            </div>
          )}
          {description && (
            <div className="border-t border-light-500 py-3 pb-5 leading-[1.9em] rtl:text-right dark:border-dark-500 dark:text-light-600 md:py-4 xl:pb-6 3xl:py-5 3xl:pb-8">
              <ComposeText text={description} />
            </div>
          )}
          <ProductInformation
            categories={categories}
            tags={tags}
            created_at={created_at}
            updated_at={updated_at}
            layoutType={type.name}
            //@ts-ignore
            icon={type?.icon}
            orders_count={orders_count}
            views_count={views_count}
            className="border-t border-light-500 py-5 dark:border-dark-500 lg:py-6 3xl:py-10"
          />
          <div className="border-t border-light-500 pt-5 dark:border-dark-500">
            <ProductSocialShare productSlug={slug} />
          </div>
        </div>
      </div>
      {in_orders && (
        <div className="lg:hidden">
          <Button
            onClick={() => (in_orders ? openReviewModal(product) : null)}
            disabled={in_orders ? false : true}
            className="my-6 w-full"
          >
            {!order_id
              ? ''
              : getReview(my_review, order_id)
              ? t('text-update-review')
              : t('text-write-review')}
          </Button>
          <span className="!mt-4 text-center italic">
            How happy are you with your purchase? Did the prompt perform as you
            anticipated? We&apos;`d love to hear your feedback on this prompt!
          </span>
        </div>
      )}
    </>
  );
}
